import * as React from "react";
import { Context } from "./_context";
export const InsightsIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5.5 19h-2V6h2v13Zm5 0h-2V2h2v17Zm5 0h-2V9h2v10Zm5 0h-2V7h2v12Z", fill: "currentColor" }));
  iconset[32] = /* @__PURE__ */ React.createElement("svg", { width: "2rem", height: "2rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5.5 9v17m14-13v13m-7-22v22m14-15.667V26", stroke: "currentColor", strokeWidth: 3, strokeLinejoin: "round" }));
  return iconset[size];
};
InsightsIcon.iconId = "Pcmgzv";
